import { render } from "./DocumentsDevices.vue?vue&type=template&id=819fe006"
import script from "./DocumentsDevices.vue?vue&type=script&lang=js"
export * from "./DocumentsDevices.vue?vue&type=script&lang=js"

import "./DocumentsDevices.vue?vue&type=style&index=0&id=819fe006&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__